import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment'

/**
 * This is a singleton class
 */
@Injectable({ providedIn: 'root' })
export class AppCountrySettings {
    //Provide all the Country Configs here

    //don't Set Value here, set in app-metadata.handler.ts
    public currentCountryCd: string = 'Indonesia';
    public currentCountryCdValue: string = 'INA'
    public currentCountryName: string = 'INDONESIA'
    public thousandSeparator: string = ","
    public hundredSeparator: string = "."

    public countryLookup = [
        {
            countryCd: 'India',
            currencyCd: 'IDR',


        }]

    constructor() {
    }

    getCountryMetaData() {
        let orgMetaData = this.countryLookup.filter(country => country.countryCd === this.currentCountryCd)
        return orgMetaData[0];
    }
}
